import { Loader } from 'app-view/components/Spinner'

export function LoadingSignature() {
  return <Loader text="Reading your signature request..." />
}
